export default {
  name: 'hanging-frame-component',
  props: [ 'large', 'full' ]
}



// WEBPACK FOOTER //
// ./src/components/hanging-frame/script.js